import Login from "../front/modules/auth/login";
import AdminLogin from "../admin/auth/login";
import FrontLogin from "../auth/Login";
import OtpVerification from "../auth/OtpVerification";
import AdminForgotPassword from "../admin/auth/ForgotPassword";
import AcceptUser from "../admin/reset-password/ResetPassword";
import UserLogin from "../front/modules/auth/login/index";
import ResetPassword from "./ResetPassword";

export const authRoute = (data) => [
  {
    path: "/login",
    title: "login",
    component: Login,
  },
  {
    path: "/accept-user",
    title: "Accept User",
    component: AcceptUser,
  },
  {
    path: "/admin/signin",
    title: "Admin Login",
    component: AdminLogin,
    routeType: "auth",
  },
  // {
  //   path: "/signin",
  //   title: "signin",
  //   component: FrontLogin,
  //   routeType: "auth",
  // },
  {
    path: "/reset-password",
    title: "Reset Password",
    component: ResetPassword,
    routeType: "auth",
  },
  {
    path: "/admin/forgot-password",
    title: "Admin Forgot Password",
    component: AdminForgotPassword,
    routeType: "auth",
  },
];
